import { clsx } from 'clsx';
import * as React from 'react';

import styles from './ChatMessageLayout.css';
import { noop } from '../../utils/noop';
import { useInView } from '@cian/valuation-utils-component';
import { TOutcomingStatus } from '../../types/messages';
import { EMessageType } from '../../types/messageType';

interface IChatMessageLayoutProps {
  messageStatus?: TOutcomingStatus;
  messageType: EMessageType;
  onShow?: VoidFunction;
}

export const ChatMessageLayout: React.FC<React.PropsWithChildren<IChatMessageLayoutProps>> = ({
  children,
  onShow = noop,
  messageType,
  messageStatus,
}) => {
  const trackedRef = React.useRef(false);

  const { ref, inView } = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });

  React.useEffect(() => {
    /** Трекаем показ только успешно отправленных и входящий сообщений */
    if (!inView || trackedRef.current || messageStatus === 'pending' || messageStatus === 'failed') {
      return;
    }

    trackedRef.current = true;

    onShow();
  }, [inView, onShow, messageStatus]);

  return (
    <div
      ref={ref}
      className={clsx(styles['message__layout'], styles[`message__layout_type_${messageType}`])}
      data-name="ChatMessageLayout"
    >
      {children}
    </div>
  );
};
